import { Type } from '@/components/common'
import { useExperimentContext } from '@/experimentation'
import { Campaign } from '@/services/api/campaign'
import useSiteAssets from '@/services/hooks/useSiteAssets'
import { formatMoney } from '@/utils'

interface Props {
  campaign: Campaign
}

const AverageInvestmentAmount: React.FC<Props> = ({ campaign }) => {
  const { amountRaised, backers, priorRaiseTotal, status } = campaign
  const siteAssets = useSiteAssets()
  const { getFeatureValue } = useExperimentContext()

  const resolvedBackers = siteAssets?.usePriorRaisesLayout
    ? priorRaiseTotal.backers + backers
    : backers

  const avgAmountRaised = amountRaised / resolvedBackers
  const showAvgInvestmentAmount =
    status === 'currently_funding' &&
    siteAssets?.showAvgInvestmentAmount &&
    getFeatureValue('avg_investment_amount', false)

  if (!showAvgInvestmentAmount) return null

  return (
    <Type as="div" variant="paragraph-lg">
      {formatMoney(avgAmountRaised, {
        isCents: true,
        zeroFractionDigits: true,
      })}{' '}
      Avg. Investment Amount
    </Type>
  )
}

export default AverageInvestmentAmount
